import axios from 'axios';
import {API} from '../config/apis';
import {createAsyncThunk, createSlice} from '@reduxjs/toolkit';
import AsyncStorage from '@react-native-async-storage/async-storage';
import i18n from 'i18next';

export const getProfile = createAsyncThunk(
  'getProfile',
  async (_, {rejectWithValue}) => {
    try {
      const userData = await AsyncStorage.getItem('Data');
      const parseUserData = JSON.parse(userData);
      const token = parseUserData?.token;
      const userId = parseUserData?.userId;
      console.log('userToken', token);
      console.log('userId', userId);
      const language = i18n.language === 'dt' ? 'du' : 'en';
      console.log('language', language);
      const response = await axios.post(
        API.GET_PROFILE_API,
        {
          userId,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            'Accept-Language': language,
          },
        },
      );
      console.log('getProfile response', response.data);
      return response.data.Data;
    } catch (err) {
      console.log('getProfile error', err.response);
      return rejectWithValue(err.response.data.Message);
    }
  },
);

export const updateProfile = createAsyncThunk(
  'updateProfile',
  async (payload, {rejectWithValue}) => {
    const userData = await AsyncStorage.getItem('Data');
    const parseUserData = JSON.parse(userData);
    const token = parseUserData?.token;
    const userId = parseUserData?.userId;
    const language = i18n.language === 'dt' ? 'du' : 'en';
    console.log('language', language);
    try {
      const response = await axios.post(
        API.UPDATE_PROFILE_API,
        {
          name: payload.name,
          email: payload.email,
          phone: payload.phone,
          userId: userId,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            'Accept-Language': i18n.language === 'dt' ? 'du' : 'en',
          },
        },
      );
      console.log('updateProfile response', response.data.updatedData);
      return response.data.updatedData;
    } catch (err) {
      console.log('updateProfile error', err.response);
      return rejectWithValue(err.response.data.message);
    }
  },
);

const profileSlice = createSlice({
  name: 'profile',
  initialState: {
    name: null,
    email: null,
    phone: null,
    error: null,
    scans: 0,
    has_answered: 0,
    getProfileLoading: false,
    updateProfileLoading: false,
    milestones: [],
    rewardLevels: [],
    max_eligible_milestone_index: 0,
  },
  extraReducers: builder => {
    builder
      .addCase(getProfile.pending, state => {
        state.getProfileLoading = true;
        state.error = null;
      })
      .addCase(getProfile.fulfilled, (state, action) => {
        console.log('getProfile fulfilled', action.payload);
        state.getProfileLoading = false;
        state.name = action.payload.name;
        state.email = action.payload.email;
        state.phone = action.payload.phone_number;
        state.scans = action.payload.scans_made;
        state.has_answered = action.payload.has_answered;

        // setting milestones, rewardLevels and max_eligible_milestone_index
        const rewards = action.payload.rewards || {};
        const rewardLevels = Object.entries(rewards)
          .filter(([k]) => /^level_\d+$/.test(k))
          .sort(
            (a, b) =>
              parseInt(a[0].match(/\d+/)[0], 10) -
              parseInt(b[0].match(/\d+/)[0], 10),
          )
          .map(([k, v]) => ({
            level: parseInt(k.match(/\d+/)[0], 10),
            milestone: v.milestone,
            status: v.status,
            brandName: v.brandName,
            logoUrl: v.logoUrl,
            couponDetails: v.couponDetails,
          }));

        state.rewardLevels = rewardLevels;
        state.milestones = rewardLevels.map(level => level.milestone);

        const milestone_idx = rewardLevels.filter(
          level => level.status === 'eligible',
        ).length;
        state.max_eligible_milestone_index = milestone_idx;

        state.error = null;
      })
      .addCase(getProfile.rejected, (state, action) => {
        state.getProfileLoading = false;
        state.error = action.payload;
      })
      .addCase(updateProfile.pending, state => {
        state.updateProfileLoading = true;
        state.error = null;
      })
      .addCase(updateProfile.fulfilled, (state, action) => {
        state.updateProfileLoading = false;
        state.name = action.payload.name;
        state.email = action.payload.email;
        state.phone = action.payload.phone_number;
        state.error = null;
      })
      .addCase(updateProfile.rejected, (state, action) => {
        state.updateProfileLoading = false;
        state.error = action.payload;
      });
  },
});

export default profileSlice.reducer;
